import { render, staticRenderFns } from "./OrganizationsTable.vue?vue&type=template&id=6569910a&scoped=true&"
import script from "./OrganizationsTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationsTable.vue?vue&type=style&index=0&id=6569910a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6569910a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
